import GuidanceRegistry from '../guidance-registry.js';
import {guidanceUtils} from "../guidance-utils.js";
import {confetti} from "../../framework/utils/confetti-animation.js";



GuidanceRegistry.register({
    type: "action-item-ewf-plan-admin-done-flex",
    prompt: getPrompt,
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
        await guidanceUtils.showPaDoneConfetti(guidanceItem, true);
    },
    helpUrl: async(guidanceItem) => {
        let enrollmentMethod = await getEnrollmentMethod(guidanceItem.employerId);
        if(isEdi(enrollmentMethod)){
            let helpArticle = await getHelpLink(`${guidanceItem.type}-for-edi`);
            return helpArticle.url;
        }
    },
    openAction: {
        text: "How to contact my representative?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Ameriflex Contacts"
    },
    actions: [
        {
            text: "Finish",
            recommended: true,
            click: async(component, guidanceItem) => {
                await component.clickCompleteAction(guidanceItem);
                
                let showSurvey = await guidanceUtils.takeSurvey(guidanceItem);

                if(showSurvey == true){
                    var url = await guidanceUtils.getImplemnetationSurveyLink(guidanceItem.employerId, guidanceItem.workflowId);
                    window.open(url, '_blank').focus();
                }
            }
        },
    ]
})

async function getPrompt(guidanceItem){

    let enrollmentMethod = await getEnrollmentMethod(guidanceItem.employerId);

    if(isEdi(enrollmentMethod)){

        let dateString = guidanceUtils.getEnrollmentDueDate(guidanceItem.planYearStartDate);

        if(guidanceItem.workflowType == "new-employer-workflow"){
            return "Your vendor will need to coordinate with our EDI team. For more information, click the ? icon.";

        } else {
            return "Renewing employers can have their vendor submit files at this stage with the new plan year elections. " +
             "Please make sure the file is updated with the future plan dates and new elections to prevent any issues with current plan years. <br>" +
             "If your vendor has never sent Ameriflex files for this group before, they will need to coordinate with our EDI team for testing. <br>" +
             "For more information, click the ? icon.";
        }
    }

    let hsaOnlyRenewal = await isHsaOnlyRenewal(guidanceItem.employerId, guidanceItem.workflowId);

    if(hsaOnlyRenewal){
        return 'Congratulations, your renewal is complete! If you need to contact your representative, the contact information is below.';
    }

    var hasPendingSpreadsheet = await employerHasAPendingSpreadsheet(guidanceItem.employerId, guidanceItem.workflowId);

    if(hasPendingSpreadsheet == true){
        return 'Congratulations, you are done with enrollments! As soon as we are done reviewing your setup and enrollments, your new accounts will appear in the portal. You will get an email notification once your post enrollment report has been created. If you need to contact your representative, the contact information is below.';
    }

    return 'Congratulations, your enrollments are done! Your benefit plans are fully set up, and participants are now enrolled. You can view a post enrollment report after 24 hours within the portal. If you need to contact your representative, the contact information is below.' ;
}

async function getEnrollmentMethod(employerId){
    return await romeApi.get(`/employer/${employerId}/enrollment-type`);
}

async function isHsaOnlyRenewal(employerId, workflowId) {
    return await romeApi.get(`employer/${employerId}/order/${workflowId}/isHsaOnlyRenewal`);
}

function isEdi(enrollmentMethod) {
    return enrollmentMethod.enrollmentType == 3;
}

async function getHelpLink(helpCode){
    return await romeApi.get(`help/${helpCode}`);
}

async function employerHasAPendingSpreadsheet(employerId, workflowId) {
    return await romeApi.get(`employer/${employerId}/spreadsheet/pending/${workflowId}`);
}


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-plan-admin-done-flex.js